var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.757 10.986C15.11 9.58 14.15 7.5 11.5 7.5c-2.805 0-4.882 4.227-5.821 6.138l-.18.362L3 19c-.5 1-1.7 5 3.5 5H16V11.5c-.078-.155-.158-.329-.243-.514zm.486 0C16.89 9.58 17.85 7.5 20.5 7.5c2.805 0 4.882 4.227 5.821 6.138l.18.362 2.5 5c.5 1 1.7 5-3.5 5H16V11.5c.078-.155.158-.329.243-.514z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/MX.5cff239dcf2cf21e6a062a676958452d.svg";
export { ForwardRef as ReactComponent };